import { useLocation } from 'react-router-dom';
import AccordionList from './AccordionList';
import { useGetBookChaptersQuery } from '../../api';
import queryString from 'query-string';
import AccordionShimmer from '../common/shimmers/AccordionShimmer';
import NoAssetsScreen from '../../pages/errorPages/NoAssets';

const ActivitiesComponent = ({ defaultRes }: any) => {
    const location = useLocation();

    const queryParams = queryString.parse(location.search);
    const bookId = queryParams.bookId;

    const {
        data: bookChaptersInfo,
        error,
        isLoading,
    } = useGetBookChaptersQuery(bookId);

    if (isLoading)
        return (
            <div>
                <AccordionShimmer />
            </div>
        );
    if (error) return <NoAssetsScreen />;
    return (
        <AccordionList
            all_videos={defaultRes === 'all_videos'}
            data={bookChaptersInfo?.data?.unitsequencemapping}
            bookId={bookId}
        />
    );
};

export default ActivitiesComponent;
